import React, { useState, useMemo, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify';
import Input from '../../Components/Form/Input';
import FormCustom from '../../Components/Form/FormCustom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const EmployeeReport = _ => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [rows, setRows] = useState([]);
  const [excel, setExcel] = useState(null);
  const [data, setData] = useState({
    p_date_start: Helpers.date.getToday(),
    p_date_end: Helpers.date.getToday(),
  });
  const [selectedPhoto, setSelectedPhoto] = useState(null); // Foto seleccionada para ampliar
  const [showModal, setShowModal] = useState(false); // Control del modal

  // Función para abrir el modal con la imagen seleccionada
  const handlePhotoClick = (photo) => {
    setSelectedPhoto(photo);
    setShowModal(true);
  };

  // Cargar el reporte basado en las fechas
  const loadRows = _ => {
    setIsProcessing(true);
    Controllers.employee.reporte_asistencia(data).then(res => {
      setRows(res.data);
      setExcel(res.excel);
    }).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => {
        setIsProcessing(false);
      });
  };

  useEffect(() => {
    loadRows()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const dtRows = useMemo(() => <ReactDataTableBootstrap
    head={[
      [
        { name: 'id_employee', text: 'ID', align: 'center' },
        { name: 'nombre_completo', text: 'Nombre', align: 'center' },
        { name: 'attendance_date', text: 'Fecha', align: 'center' },
        { name: 'entrada', text: 'Entrada', align: 'center' },
        { name: 'salida_refrigerio', text: 'Salida Refrigerio', align: 'center' },
        { name: 'entrada_refrigerio', text: 'Entrada Refrigerio', align: 'center' },
        { name: 'salida', text: 'Salida', align: 'center' },
        {
          name: 'foto_entrada',
          text: 'Foto Entrada',
          align: 'center',
          render: r => !r.foto_entrada ? '' : <img src={Helpers.config.resourcesUrl({ url: r.foto_entrada })} alt="Foto Entrada" width="100" onClick={() => handlePhotoClick(Helpers.config.resourcesUrl({ url: r.foto_entrada }))} className='cur-pointer' />
        },
        {
          name: 'foto_salida_refrigerio',
          text: 'Foto Salida Refrigerio',
          align: 'center',
          render: r => !r.foto_salida_refrigerio ? '' : <img src={Helpers.config.resourcesUrl({ url: r.foto_salida_refrigerio })} alt="Foto Salida Refrigerio" width="100" onClick={() => handlePhotoClick(Helpers.config.resourcesUrl({ url: r.foto_salida_refrigerio }))} className='cur-pointer' />
        },
        {
          name: 'foto_entrada_refrigerio',
          text: 'Foto Entrada Refrigerio',
          align: 'center',
          render: r => !r.foto_entrada_refrigerio ? '' : <img src={Helpers.config.resourcesUrl({ url: r.foto_entrada_refrigerio })} alt="Foto Entrada Refrigerio" width="100" onClick={() => handlePhotoClick(Helpers.config.resourcesUrl({ url: r.foto_entrada_refrigerio }))} className='cur-pointer' />
        },
        {
          name: 'foto_salida',
          text: 'Foto Salida',
          align: 'center',
          render: r => !r.foto_salida ? '' : <img src={Helpers.config.resourcesUrl({ url: r.foto_salida })} alt="Foto Salida" width="100" onClick={() => handlePhotoClick(Helpers.config.resourcesUrl({ url: r.foto_salida }))} className='cur-pointer' />
        },
      ],
    ]}
    rows={rows}
    pageLength={100}
    isProcessing={isProcessing}
  />, [rows, isProcessing]);

  return <>
    <Card>
      <Card.Header className="justify-content-between">
        <span>Reporte de Asistencia</span>
      </Card.Header>
      <Card.Body>
        {excel?.file && <div className='mb-3'>
          <a href={excel.file} download={excel.filename}>
            <Button size="sm" variant="success">
              <i className="fa fa-file-excel mr-2"></i>
              Descargar Excel
            </Button>
          </a>
        </div>}
        <FormCustom viewSubmit={false} onSubmit={_ => {
          if (!data.p_date_start || !data.p_date_end) {
            Helpers.toast.construct({
              response: 'warning',
              message: 'Seleccione las fechas',
              toast
            });
            return false;
          }
          loadRows();
        }}>
          <Input
            classNameParent="col-6 mb-2"
            type="date"
            icon="far fa-calendar-alt"
            placeholder="Fecha Inicio"
            text="Fecha Inicio"
            required
            value={data.p_date_start}
            onChange={e => {
              setData({ ...data, p_date_start: e.currentTarget.value });
            }}
          />
          <Input
            classNameParent="col-6 mb-2"
            type="date"
            icon="far fa-calendar-alt"
            placeholder="Fecha Fin"
            text="Fecha Fin"
            required
            value={data.p_date_end}
            onChange={e => {
              setData({ ...data, p_date_end: e.currentTarget.value });
            }}
          />
          <div className="col-4 mb-2">
            <Button type="submit" size="sm">
              <i className="fa fa-search"></i> Buscar
            </Button>
          </div>
        </FormCustom>
        {dtRows}
      </Card.Body>
    </Card>

    {/* Modal para mostrar la foto en grande */}
    <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Foto de Asistencia</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {selectedPhoto && <img src={selectedPhoto} alt="Foto Ampliada" className="img-fluid" />}
      </Modal.Body>
    </Modal>
  </>;
};

export default EmployeeReport;
